
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [{"enable-background":"new 0 0 363.025 363.024"},style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Capa_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","width":"363.025px","height":"363.024px","viewBox":"0 0 363.025 363.024","style":"enable-background:new 0 0 363.025 363.024;","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('g',[_c('path',{staticStyle:{"fill":"#fff"},attrs:{"fill":"currentColor","d":"M181.512,0C81.43,0,0,81.427,0,181.513c0,100.082,81.43,181.512,181.512,181.512\n\t\tc100.083,0,181.513-81.424,181.513-181.512C363.025,81.421,281.595,0,181.512,0z M181.512,351.32\n\t\tc-73.487,0-136.2-46.939-159.79-112.388l197.877,0.383l-35.463,35.469l8.914,8.909l50.639-50.65l-51.53-51.524l-8.909,8.914\n\t\tl36.287,36.286l-201.783-0.4c-3.914-14.277-6.044-29.287-6.044-44.795c0-93.632,76.17-169.802,169.802-169.802\n\t\tc73.482,0,136.203,46.931,159.79,112.391l-196.888-0.38l35.466-35.466l-8.912-8.911l-50.645,50.65l51.528,51.525l8.911-8.911\n\t\tl-36.286-36.292l200.794,0.4c3.917,14.287,6.044,29.299,6.044,44.809C351.315,275.14,275.139,351.32,181.512,351.32z"}})]),_c('g'),_c('g'),_c('g'),_c('g'),_c('g'),_c('g'),_c('g'),_c('g'),_c('g'),_c('g'),_c('g'),_c('g'),_c('g'),_c('g'),_c('g')])
          )
        }
      }
    